import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TableService} from '@app/ps/services/table.service';
import {SettingsService} from '@app/ps/services/settings.service';
import {UserNamePipe} from '@app/common/pipes/username.pipe';
import {GeometricPlanRequestModel} from '@app/ps/models/geometric-plan-request.model';
import {TitleModel} from '@app/common/models/title.model';
import * as _ from 'lodash';
import {GeometricPlanRequestService} from '@app/ps/services/geometric-plan-request.service';

@Component({
  selector: 'table-geometric-plan-request',
  templateUrl: './table-geometric-plan-request.component.html',
})
export class TableGeometricPlanRequestComponent implements OnInit {
  @Input() list: any;
  @Input() clickable = false;
  @Output() sort = new EventEmitter();
  @Output() onclick = new EventEmitter();

  constructor(
    private tableService: TableService,
    private settingsService: SettingsService,
    public userNamePipe: UserNamePipe,
    public requestService: GeometricPlanRequestService,
  ) {}

  private readonly TABLE_ID = 'geometricPlanRequests';
  public isArray = Array.isArray;

  ngOnInit() {
  }

  onClick(geometricPlan: GeometricPlanRequestModel) {
    this.onclick.emit(geometricPlan);
  }

  onSort(column: string, ascOrDesc: string) {
    this.sort.emit({
      column,
      ascOrDesc,
    });
  }

  hideColumn(columnId: string): boolean {
    return this.settingsService.shouldHideColumn(this.TABLE_ID, columnId);
  }

  getColumnName(columnId: string): string {
    return this.tableService.getColumnById(this.TABLE_ID, columnId).name;
  }

  getTitles(geometricPlanRequest: GeometricPlanRequestModel): TitleModel[] {
    const titles = geometricPlanRequest.parcels
      .filter(p => p.title)
      .map(p => p.title);
    return _.uniqBy(titles, 'id');
  }
}
